/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package DGD Platinum
 * @since   1.0.0
 */

import './modules/theme/polyfills';
import './modules/theme/webfonts';
import './modules/theme/images';
import './modules/theme/object-fit-videos';
import './modules/theme/lightboxes';
import './modules/theme/forms';
import './modules/theme/scroll-to';
import './modules/theme/sticky-header';
import './modules/theme/main-menu';
import './modules/theme/mobile-footer-menu';
import './modules/theme/comment-reply';
import './modules/theme/stats';
import './modules/theme/card-slider';
import './modules/theme/scrollbar';
